import React from "react";
import '../css/card.css'
import hands from '../assets/hands.png'
import { Link } from "react-router-dom";

const Card = () => {
    return (
        <div className="contcard" >

            <div className="outer" >
                <div className="card servicesourcingbg" >
                </div>

            </div>
            <div className="outer" >
                <div className="card serviceitbg" >
                </div>

            </div>
            <div className="outer" >

                <div className="card servicepharmacobg" >
                </div>

            </div>
            <div className="outer" >
                <div className="card serviceregulatoryaffairsbg" >
                </div>

            </div>
            <div className="outer" >

                <div className="card serviceclinicaldevelopmentbg" >
                </div>

            </div>

        </div>
    )
}
export default Card;